import { getSafeReturnUrl } from 'utils/sessionSharing'

// The Sou-Sou site links to /my-profile/payment-methods?returnTo=<absolute allow-listed URL>. The validated URL is also kept
// in sessionStorage (15 min) so it survives a reload, a full-page 3-D Secure redirect and the sign-in hop; it is cleared when
// the user leaves the page inside the app, after the redirect and on expiry, so an old visit cannot redirect a later add.
const KEY = 'tl-card-return'
const TTL_MS = 15 * 60 * 1000

export const clearReturnTo = () => {
  try { sessionStorage.removeItem(KEY) } catch (error) { /* storage unavailable */ }
}

const save = (url, now) => {
  try { sessionStorage.setItem(KEY, JSON.stringify({ url, savedAt: now })) } catch (error) { /* storage unavailable */ }
}

const stored = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY)) } catch (error) { return null }
}

// The URL param wins (valid: remembered; present but unsafe: forgotten, nothing is redirected); without it a stored,
// unexpired value that still validates is used.
export const loadReturnTo = (search = '', now = Date.now()) => {
  const params = new URLSearchParams(search)
  if (params.has('returnTo')) {
    const url = getSafeReturnUrl(params.get('returnTo'))
    if (url) save(url, now)
    else clearReturnTo()
    return url
  }
  const entry = stored()
  const age = entry && now - entry.savedAt
  const url = entry && age >= 0 && age <= TTL_MS ? getSafeReturnUrl(entry.url) : null
  if (!url) clearReturnTo()
  return url
}
